import { Routes, Route, Navigate } from 'react-router-dom';

import CompanyAnnouncementsListView from './views/list'
import CompanyAnnouncementDetailView from './views/detail';
import { useSecurity } from '../../../../config/hooks';
import { P_LEAD_MANAGER, P_GESTIONE_LEAD_DETAIL, P_GL_AGENTE, P_GL_AREA_MANAGER, P_TEAM_LEADS } from '../../../../config/helpers/permissionsHash';
import UserAnnouncementsListView from './views/listAgent';
import UserAnnouncementDetailView from './views/detailAgent';
import Redirect from './components/redirect';

import TeamAnnouncementsListView from './views/listTeam'
import TeamAnnouncementDetailView from './views/detailTeam';

const DashboardRouter = () => {
    const LM = useSecurity(P_LEAD_MANAGER);
    const LMA = useSecurity(P_GL_AGENTE);
    const DGL = useSecurity(P_GESTIONE_LEAD_DETAIL)
    const LMAM = useSecurity(P_GL_AREA_MANAGER);
    const LTEAM = useSecurity(P_TEAM_LEADS);
    return (
        <Routes>
            <Route path='/' element={<Navigate to={`/admin/client/dashboard/list`} />}></Route>
            {LM && <>
                <Route path='/list' element={<CompanyAnnouncementsListView />} />
            </>}
            {LTEAM && <><Route path='/team/list' element={<TeamAnnouncementsListView />} />
            <Route path='/team/detail/:id' element={<TeamAnnouncementDetailView />} /></>}
            {DGL && <>
                    <Route path='/detail/:id/:companyId' element={<CompanyAnnouncementDetailView />} />
            </>}
            <Route path='/detail/:id' element={<Redirect />} />
            {LMA && <>
                <Route path='/agentlist' element={<UserAnnouncementsListView />} />
                <Route path='/detail/user/:id/:userId' element={<UserAnnouncementDetailView />} />
            </>}
            {LMAM && <>
                <Route path='/areManagerlist' element={<UserAnnouncementsListView roleName="AREA_MANAGERS" />} />
                <Route path='/detail/user/:id/:userId' element={<UserAnnouncementDetailView roleName="AREA_MANAGERS"/>} />
            </>}
            <Route path="*" element={<Navigate to="/error" />} />
        </Routes>
    )
}

export default DashboardRouter;